import React, { createContext, useContext } from "react";

/**
 * True when the subtree is rendered as a non-interactive preview (e.g. the
 * landing-page feed via <PreviewStatus>). Consumers read it to skip side
 * effects that make no sense in a decorative, unauthenticated context — most
 * notably the per-video metadata fetch in <StatusVideoPlayer>.
 *
 * Defaults to `false`, so components rendered without a provider behave
 * normally and don't need to opt in.
 */
const PreviewContext = createContext(false);

const PreviewProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <PreviewContext.Provider value={true}>{children}</PreviewContext.Provider>;

const usePreview = (): boolean => useContext(PreviewContext);

export { PreviewProvider, usePreview };
